// Shrinks large photos (phone cameras produce 5–10 MB files) before upload.
// Small images, GIFs and SVGs are returned unchanged; on any failure the original is used.
export async function downscaleImage(file, maxDim = 2560, quality = 0.85) {
  if (!file.type.startsWith('image/') || /gif|svg/.test(file.type)) return file;
  try {
    // createImageBitmap applies the EXIF orientation, so portrait phone photos stay upright
    const bmp = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const scale = Math.min(1, maxDim / Math.max(bmp.width, bmp.height));
    if (scale === 1 && file.size < 1.5 * 1024 * 1024) { bmp.close(); return file; }

    const canvas = document.createElement('canvas');
    canvas.width  = Math.round(bmp.width  * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext('2d').drawImage(bmp, 0, 0, canvas.width, canvas.height);
    bmp.close();

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob || blob.size >= file.size) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return file;
  }
}
